export default __webpack_public_path__ + "static/media/glygen-logoW.05d08cb9.svg";